import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';
import { useDevice } from '@contexts/device';

import {
  StyledListingItemTimeZone,
  TextContainer,
  TimeZoneLocationLabel,
} from './ListingItemTimeZoneStyle';
import { ListingItemTimeZoneProps } from './ListingItemTimeZoneInterface';

const ListingItemTimezone = ({
  text,
  icon,
  iconColor = 'tomato',
  iconSize = 16,
  className,
  textColor = 'black',
  CustomIconComponent,
  distanceFromCenter,
}: ListingItemTimeZoneProps) => {
  const { isDesktop } = useDevice();
  return (
    <StyledListingItemTimeZone className={className}>
      {CustomIconComponent ? <CustomIconComponent /> : null}
      <CustomIcon icon={icon} fontSize={iconSize} paletteColor={iconColor} />
      <TextContainer>
        <TimeZoneLocationLabel textColor={textColor}>
          {text}
        </TimeZoneLocationLabel>
        {distanceFromCenter && distanceFromCenter > 0 ? (
          <Typography weight='SemiBold' variant='caption2'>
            {isDesktop ? '· Merkez: ' : 'Merkez: '}
            <Typography>{`${distanceFromCenter
              ?.toString()
              .replace('.', ',')} km`}</Typography>
          </Typography>
        ) : null}
      </TextContainer>
    </StyledListingItemTimeZone>
  );
};

export default ListingItemTimezone;
